<template>
  <div class="formfield">
    <input
      type="file"
      ref="file"
      v-on:change="onFileChange"
      style="position: absolute; width: 1px; height: 1px; opacity: 0; overflow: hidden; clip: rect(0 0 0 0);"
    />
    <button type="button" class="upload-button" @click="onButtonClick">
      {{ buttonName }}
    </button>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from "vuex";

export default {
  props: {
    vuexStore: {
      type: String,
      default: null,
    },
    vuexSelectAction: {
      type: String,
      default: null,
    },
    vuexUploadAction: {
      type: String,
      default: null,
    },
    setDescription: {
      type: Boolean,
      default: false,
    },
    buttonName: {
      type: String,
      default: null,
    },
    attachTo: {
      type: Object,
      default: null,
    }
  },

  data() {
    return {
      file: "",
    };
  },

  computed: {
    ...mapState("fileUpload", {
      sendLoader: (state) => state.sendLoader,
      canSelectFile: (state) => state.canSelectFile,
      canUploadFile: (state) => state.canUploadFile,
    }),
  },

  methods: {
    onButtonClick() {
      const input = this.$refs.file;
      if (input) {
        input.click();
      }
    },

    onFileChange(e) {
      //console.log(e.target.value);
      this.file = this.$refs.file.files[0];
      VueStore.dispatch("fileUpload/toggleBooleanState", {
        key: this.vuexSelectAction,
        bool: true,
      });

      if (this.setDescription) {
        VueStore.dispatch(
          this.vuexStore + "/setDefaultDescription",
          this.file.name
        );
      }

      if (this.attachTo !== null){
        VueStore.dispatch(this.vuexStore + "/setVariable", {
          key: 'attachTo',
          value: this.attachTo,
        });
      }

      this.uploadFile();
    },

    uploadFile() {
      if (typeof this.file != "undefined" && this.file != "") {
        VueStore.dispatch(
          this.vuexStore + "/" + this.vuexUploadAction,
          this.file
        );
        this.file = "";
      }
    },

    clearUpload() {
      //console.log('clear');
      //$('#file').val(null);
      //$('#file').val('');

      $("<form>").closest("form").get(0).reset();
    },
  },

  mounted() {
    $("form.file-upload").on("submit", function (e) {
      e.preventDefault();
    });
  },
};
</script>
<style>
.upload-button {
  margin: 0 !important;
  min-width: 100px;
  cursor: pointer;
}
</style>
